<template>
  <o-modal
    ref="modal"
    :title="$t('components.schedule.actions.moveBreak.title')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel', callback: handleCancel },
      { text: $t('general.confirm'), type: 'confirm', callback: handleConfirm },
    ]"
    modal-class="m-2 bg-gray-50 rounded-lg shadow-lg pointer-events-auto overflow-hidden sm:max-w-md sm:w-full h-full max-h-lg dark:bg-gray-900"
    content-class="mx-auto max-w-lg h-full flex flex-col bg-white dark:bg-gray-900"
  >
    <div class="text-left h-full">
      <o-scroll class="h-full">
        <div class="text-base leading-5 text-gray-600 dark:text-gray-300">
          <p class="mb-6">
            {{ $t('components.schedule.actions.moveBreak.areYouSure') }}
          </p>

          <div v-if="employeeBreak">
            <p class="text-gray-600 text-xs uppercase tracking-wider mb-2 dark:text-gray-300">
              {{ $t('components.schedule.actions.moveBreak.ogDetails') }}
            </p>
            <div class="flex items-center last:mb-0 p-2 rounded-xl bg-gray-50 border mb-10 dark:bg-gray-900">
              <div class="flex-shrink-0 text-gray-700 font-semibold mr-4 dark:text-gray-200">
                <p>
                  {{ $date.minutes(employeeBreak.original.time) }}
                </p>
                <p>
                  {{ $date.minutes(employeeBreak.original.time + employeeBreak.original.duration) }}
                </p>
              </div>
              <div class="w-full">
                <p v-if="employeeBreak.original.employee" class="text-gray-700 text-sm font-medium leading-none mb-2 dark:text-gray-200">
                  {{ employeeBreak.original.employee.displayName }}
                </p>
                <p class="text-sm text-gray-600 dark:text-gray-300 flex flex-wrap leading-none">
                  <span class="mr-4">
                    {{ $t('datetime.increments.mins', { mins: employeeBreak.original.duration }, Number(employeeBreak.original.duration)) }}
                  </span>

                  <span class="mr-4">
                    {{ $date.convert(employeeBreak.original.date.value, undefined, $date.presets.long) }}
                  </span>
                </p>
              </div>
            </div>

            <p class="text-gray-600 text-xs uppercase tracking-wider mb-2 dark:text-gray-300">
              {{ $t('components.schedule.actions.moveBreak.newDetails') }}
            </p>
            <div class="flex items-center mb-2 last:mb-0 p-2 rounded-xl bg-gray-50 border dark:bg-gray-900">
              <div class="flex-shrink-0 text-gray-700 font-semibold mr-4 dark:text-gray-200">
                <p>
                  {{ $date.minutes(employeeBreak.time) }}
                </p>
                <p>
                  {{ $date.minutes(employeeBreak.time + employeeBreak.duration) }}
                </p>
              </div>
              <div class="w-full">
                <p v-if="employeeBreak.employee" class="text-gray-700 text-sm font-medium leading-none mb-2 dark:text-gray-200">
                  {{ employeeBreak.employee.displayName }}
                </p>
                <p class="text-sm text-gray-600 dark:text-gray-300 flex flex-wrap leading-none">
                  <span class="mr-4">
                    {{ $t('datetime.increments.mins', { mins: employeeBreak.duration }, Number(employeeBreak.duration)) }}
                  </span>

                  <span class="mr-4">
                    {{ $date.convert(employeeBreak.date.value, undefined, $date.presets.long) }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </o-scroll>
    </div>
  </o-modal>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  'update:loading': [value: boolean]
  'cancel': []
  'success': []
}>()

const { $api, $notification, $bus, $date, $i18n } = useNuxtApp()

const modal = ref<any>(null)

const employeeBreak = ref<any>(null)

function open(eb: any) {
  employeeBreak.value = eb
  modal.value.open()
}

async function handleConfirm() {
  try {
    const eb = employeeBreak.value
    const { date, time, duration, label, employee, original } = eb
    const fromDate = $date.timestamp($date.getStartOfDayUTC(original.date.date))
    const toDate = $date.timestamp($date.getStartOfDayUTC(date.date))
    const success = await $api.roster.moveBreak(eb, fromDate, toDate, employee, time, duration, label)

    emit('update:loading', false)

    if (success) {
      employeeBreak.value.original = {
        ...employeeBreak.value.original,
        time,
        duration,
        date
      }

      $notification.toast({
        title: $i18n.t('schedule.updatedBreak'),
        variant: 'success',
      })

      $bus.emit.updated('EmployeeBreak', employeeBreak.value)

      emit('success')
      return true
    }
  } catch (e: any) {
    console.log(e)
    $notification.error({ errors: e?.errors })
  }
}

function handleCancel() {
  emit('cancel')
  return true
}

defineExpose({ open })
</script>
